var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 18,
    rx: 4.5,
    fill: "black",
    fillOpacity: 0.2,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15C9 15.5523 9.44772 16 10 16C10.5523 16 11 15.5523 11 15L9 15ZM10.7071 3.29289C10.3166 2.90237 9.68342 2.90237 9.29289 3.29289L2.92893 9.65685C2.53841 10.0474 2.53841 10.6805 2.92893 11.0711C3.31946 11.4616 3.95262 11.4616 4.34315 11.0711L10 5.41421L15.6569 11.0711C16.0474 11.4616 16.6805 11.4616 17.0711 11.0711C17.4616 10.6805 17.4616 10.0474 17.0711 9.65685L10.7071 3.29289ZM11 15L11 4L9 4L9 15L11 15Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.2f68aabab37ce92e8bc852188247b0ec.svg";
export { ForwardRef as ReactComponent };